import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import PackageForm from "./PackageForm";
import { ApiError } from "components";
import { resetPackage, updatePackage } from "../../../store/action";
import { PackageProps, CreatePackageInput, CreatePackageError, UpdatePackageInput } from "../../../store/actionType";
type OwnProps = {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  packageData: PackageProps;
};
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleUpdatePackage: React.FC<Props> = ({
  closeModal,
  onUpdatePackage,
  packageData,
  onResetPackage
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [formData, setFormData] = useState<CreatePackageInput>({
    name: packageData.name || "",
    description: packageData.description || "",
    package_type: packageData.package_type || "",
    package_order: packageData.package_order || 0,
    information: packageData.information || "",
  });
   const packageState = useSelector(
    (state: any) => state.packages.updatePackageState
  );
  const [error, setError] = useState<CreatePackageError>({});
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const validateForm = () => {
    const errors: CreatePackageError = {};
    if (!formData.name.trim()) errors.name = "Package Name is required";
    if (!formData.description.trim())
      errors.description = "Package Description is required";
    if (!formData.package_type.trim())
      errors.package_type = "Package Type is required";
    if (!formData.package_order)
      errors.package_order = "Package order is required";
    if (!formData.information)
      errors.package_order = "Information is required";
    setError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (
      formData.name.trim() !== "" &&
      formData.description.trim() !== "" &&
      formData.package_type.trim() !== ""
    ) {
      setSubmitted(true)
      setLoading(true);
      const input: UpdatePackageInput = {
        name: formData.name || "",
        description: formData.description || "",
        package_type: formData.package_type || "",
        package_id: packageData.id.toString() || "",
        package_order: formData.package_order || 0,
        information:formData.information
      };
      try {
        await onUpdatePackage(input);
      } catch (err) {
        console.error("Failed to create package:", err);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    onResetPackage()
        if (!packageState.isLoading && submitted) {
          if (packageState.error) {
            setApiError(packageState.error); // show error
          } else {
            setApiError(null);
            closeModal(false);
          }
        }
      }, [packageState.isLoading, packageState.error, submitted]);
  return (
    <>
      <PackageForm
        handleSave={handleSave}
        formData={formData}
        handleChange={handleChange}
        error={error}
        loading={loading}
        header={"Update Package"}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onUpdatePackage: (input: UpdatePackageInput) =>
    dispatch(updatePackage(input)),
  onResetPackage: () => dispatch(resetPackage()),
});
export default connect(null, mapDispatchToProps)(HandleUpdatePackage);
